import { Alert } from '@mui/material';
import { forwardRef } from 'react';

const severityByTone = {
  neutral: 'info',
};

const neutralSx = {
  borderColor: 'rgba(216, 199, 164, 0.95)',
  borderLeftColor: 'rgba(157, 106, 37, 0.86)',
  backgroundImage:
    'linear-gradient(135deg, rgba(255,250,239,0.98) 0%, rgba(245,241,230,0.96) 100%)',
  '& .MuiAlert-icon': {
    color: 'secondary.dark',
  },
};

const TavernAlert = forwardRef(function TavernAlert(
  { children, dashed = false, severity = 'info', variant = 'standard', sx, ...props },
  ref
) {
  const alertSeverity = severityByTone[severity] || severity;

  return (
    <Alert
      ref={ref}
      severity={alertSeverity}
      variant={variant}
      sx={{
        width: '100%',
        ...(severity === 'neutral' ? neutralSx : null),
        ...(dashed ? { borderStyle: 'dashed' } : null),
        ...sx,
      }}
      {...props}
    >
      {children}
    </Alert>
  );
});

export default TavernAlert;
